import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useUserStore } from "@/stores/userStore";

import { ref } from "vue";
import ChangePasswordForm from "./ChangePasswordForm.vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "ChangePassword",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClickCloseButton"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const emitOnClickCloseButton = () => {
  setTimeout(() => {
    emit("onClickCloseButton");
  }, 300);
};

const userStore = useUserStore();
const userId = ref("");
userId.value = userStore.loginId ?? "";

const shouldShowModal = ref(true);

const toggleShowModal = (show: boolean) => {
  shouldShowModal.value = show;
};

const handleClickCloseButton = () => {
  toggleShowModal(false);
  emitOnClickCloseButton();
};

const __returned__ = { emit, emitOnClickCloseButton, userStore, userId, shouldShowModal, toggleShowModal, handleClickCloseButton, NavigationBar, ChangePasswordForm, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})